export default {
  location: {
    default: 'Lieu | Lieux',
    list: {
      page_title: 'Liste des lieux'
    },
    edit: {
      page_title: 'Modification du lieu :'
    },
    show: {
      page_title: 'Fiche du lieu :',
      tab_title: {
      }
    },
    create: {
      page_title: "Création d'un lieu"
    },
    empty_list: 'Compléter la recherche'
  }
}
